export const buildOrderItems = (order, currencyCode) => {
  if (!order) return []
  return order.lineItems.edges.map(e => ({
    ...e.node,
    price: {
      currency:
        e.node?.discountedTotalSet?.shopMoney?.currencyCode || currencyCode,
    },
    refundQuantity: 0,
    quantity: e.node.currentQuantity,
  }))
}

export const buildDefaultRefundEntity = () => {
  return {
    total: 0.0,
    subtotal: 0.0,
    shipping: 0.0,
    taxes: 0.0,
  }
}

export const buildRefundEntityFromShopifyCalculation = (
  data,
  shippingValue
) => {
  const { refund } = data
  const { refund_line_items: items, shipping, transactions } = refund
  const refundEntity = {
    total: 0.0,
    subtotal: 0.0,
    shipping: 0.0,
    taxes: 0.0,
    restocks: {},
  }
  items.forEach(lineItem => {
    const subtotal = lineItem.subtotal * 100
    const tax = lineItem.total_tax * 100
    refundEntity.subtotal += subtotal
    refundEntity.taxes += tax
    const gid = `gid://shopify/LineItem/${lineItem.line_item_id}`
    const locationGid = `gid://shopify/Location/${lineItem.location_id}`

    refundEntity.restocks[gid] = {
      locationId: locationGid,
      restockType: lineItem.restock_type,
    }
  })

  const maxShippingValue = shipping.maximum_refundable * 100
  refundEntity.maximumRefundableShipping = maxShippingValue

  const newShippingValue = shippingValue * 100
  refundEntity.shipping =
    newShippingValue > maxShippingValue ? maxShippingValue : newShippingValue

  refundEntity.taxes += shipping.tax * 100

  refundEntity.total =
    refundEntity.subtotal + refundEntity.taxes + refundEntity.shipping

  refundEntity.maximumRefundableTotal = transactions.reduce((sum, t) => {
    return sum + t.maximum_refundable * 100
  }, 0)

  refundEntity.transactions = transactions

  return refundEntity
}
